import { trataDadosFiscaisProduto } from '../components/VendaProdutoServico/cadastro/atualizarAliquotaUtils';
import {
  normalizarServicoFiscalParaSalvar,
  possuiIbsCbsUtilizado,
} from '../components/VendaProdutoServico/cadastro/servicoFiscalVendaUtils';

export const mapFormValuesToCalculoTotaisRequest = (values) => {
  const produtosServicos = (values?.produtosServicos || []).map((item) => {
    const { produtoServico, fiscal, servicoFiscal, valor, quantidade, id } = item;
    const isProduto = !!produtoServico?.produtoId;
    const isServico = !!produtoServico?.servicoId;
    const possuiIbsCbs = servicoFiscal ? possuiIbsCbsUtilizado(servicoFiscal) : false;

    return {
      id: id || null,
      produtoId: produtoServico?.produtoId || null,
      servicoId: produtoServico?.servicoId || null,
      valor: valor ?? 0,
      quantidade: quantidade ?? 0,
      fiscal: isProduto ? trataDadosFiscaisProduto(fiscal) : null,
      servicoFiscal: isServico ? normalizarServicoFiscalParaSalvar(servicoFiscal, possuiIbsCbs) : null,
    };
  });

  return {
    produtosServicos,
    valorFrete: values?.valorFrete || 0,
    tipoDesconto: values?.tipoDesconto,
    valorDesconto: values?.valorDesconto,
  };
};

/** Mapeia a venda retornada pela API (Visualizar) para o payload de calcular-totais. */
export const mapVendaApiToCalculoTotaisRequest = (venda) => {
  const produtosServicos = (venda?.produtosServicos || []).map((item) => {
    const isProduto = !!item?.produto?.id;
    const isServico = !!item?.servico?.id;
    const possuiIbsCbs = item.servicoFiscal ? possuiIbsCbsUtilizado(item.servicoFiscal) : false;

    return {
      id: item.id || null,
      produtoId: item?.produto?.id || null,
      servicoId: item?.servico?.id || null,
      valor: item.valor ?? 0,
      quantidade: item.quantidade ?? 0,
      fiscal: isProduto ? trataDadosFiscaisProduto(item.fiscal) : null,
      servicoFiscal: isServico ? normalizarServicoFiscalParaSalvar(item.servicoFiscal, possuiIbsCbs) : null,
    };
  });

  return {
    produtosServicos,
    valorFrete: venda?.valorFrete || 0,
    tipoDesconto: venda?.tipoDesconto,
    valorDesconto: venda?.valorDesconto,
  };
};
